"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeTemplate = void 0;
var tslib_1 = require("tslib");
var time_dot_1 = (0, tslib_1.__importDefault)(require("./time.dot"));
var timeTemplate = time_dot_1.default.default ? time_dot_1.default.default : time_dot_1.default;
exports.timeTemplate = timeTemplate;
//# sourceMappingURL=index.js.map